import React from "react";
import "./roboto/roboto.css";
import "./roboto-slab/roboto-slab.css";
import GlobalStyleProvider from "../GlobalStyleProvider";

const globalStyles = `
  *,
  *:before,
  *:after {
    font-family: Roboto, sans-serif;
    text-rendering: optimizeLegibility;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }
`;

export default function GlobalFontProvider() {
  return <GlobalStyleProvider styles={globalStyles} />;
}
